exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-oculta label {\n  font-size: 0px;\n}", ""]);

// exports
